import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Color } from '@app/shared/models/color.model';
import { Style } from '@app/shared/components/atoms/icon/icon.component';
import { AlertLogLevel } from '@app/shared/models/alert-log.model';
import { InvoicesSummary } from '@app/shared/interfaces/invoice.interface';

@Component({
  selector: 'app-summary-invoices',
  templateUrl: './summary-invoices.component.html',
  styleUrls: ['./summary-invoices.component.scss'],
  standalone: false,
})
export class SummaryInvoicesComponent implements OnInit, OnChanges {
  protected readonly Color = Color;

  protected readonly Style = Style;

  readonly alertLogLevel = AlertLogLevel;

  @Input() invoicesSummary: InvoicesSummary | undefined;

  @Input() error: boolean = false;

  @Input() loading: boolean = false;

  invoicesInformations = {
    valideInvoices: 0,
    invalidInvoices: 0,
    totalInvoices: 0,
  };

  private updateInvoicesInformations() {
    this.invoicesInformations.valideInvoices = this.invoicesSummary?.validInvoices ?? 0;
    this.invoicesInformations.invalidInvoices = this.invoicesSummary?.invalidInvoices ?? 0;
    this.invoicesInformations.totalInvoices = this.invoicesSummary?.totalInvoices ?? 0;
  }

  ngOnInit() {
    this.updateInvoicesInformations();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['invoicesSummary'] && this.invoicesSummary) {
      this.updateInvoicesInformations();
    }
  }
}
